import React from "react";

import { ItemContainer, StatsContainer } from "../../../charts/calendar/LateActivitiesCounter/style";
import { CounterSkeleton } from "./styles";

const CounterSkeletonList = ({ numberOfCounters = 4 }: { numberOfCounters?: number }) => (
  <>
    {Array.from({ length: numberOfCounters }, (_, index) => (
      <ItemContainer key={index}>
        <CounterSkeleton />
      </ItemContainer>
    ))}
  </>
);

const LateActivitiesCounterSkeleton = () => (
  <StatsContainer>
    <CounterSkeletonList />
  </StatsContainer>
);

export default LateActivitiesCounterSkeleton;
